import React from 'react';

export const Cases = React.lazy(() => import('./Cases/Cases'));
export const CreateCase = React.lazy(() => import('./Cases/pages/CreateCase/CreateCase'));
export const ViewCase = React.lazy(() => import('./Cases/pages/ViewCase/ViewCase'));
export const EditCaseOptions = React.lazy(() => import('./Cases/pages/EditCaseOptions/EditCaseOptions'));
export const EditCase = React.lazy(() => import('./Cases/pages/EditCase/EditCase'));
export const CommerceTexts = React.lazy(() => import('./CommerceTexts/CommerceTexts'));

export const CasesInformation = React.lazy(() => import('./CasesInformation/Casesinformation'));

export const Dashboard = React.lazy(() => import('./Dashboard/Dashboard'));
export const Minutes = React.lazy(() => import('./Minutes/Minutes'));
export const MinuteEditor = React.lazy(
  () => import('./Minutes/pages/MinuteEditor/MinuteEditor')
);
export const ViewMinute = React.lazy(
  () => import('./Minutes/pages/ViewMinute/ViewMinute')
);
export const Invoices = React.lazy(() => import('./Invoices/Invoices'));
export const InvoiceEditor = React.lazy(
  () => import('./Invoices/pages/InvoiceEditor/InvoiceEditor')
);
